/**
 * Chakra paints avatar initials `white` on a dark circle and `gray.800` on a
 * light one. Both are theme tokens that flip in dark mode, while the circle's
 * colour (hashed from the name) does not, so the initials disappeared. Keep
 * Chakra's choice but with fixed colours.
 *
 * Chakra's own helpers live in `@chakra-ui/theme-tools`, which is not a direct
 * dependency; these two mirror them.
 */

/** Chakra's `randomColor({ string })`: a stable colour hashed from the name. */
export const colorFromName = (name: string): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
    hash &= hash;
  }
  let color = '#';
  for (let j = 0; j < 3; j += 1) {
    const value = (hash >> (j * 8)) & 255;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
};

/** Chakra's `isDark`: perceived brightness below the midpoint. */
export const isDarkHex = (hex: string): boolean => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 128;
};

export const Avatar = {
  baseStyle: ({ name }: { name?: string }) => ({
    container: {
      // No name: Chakra's grey circle, which is dark enough for white text.
      color:
        !name || isDarkHex(colorFromName(name)) ? 'static-white' : 'on-light',
    },
  }),
};
